<template>
  <dashboard-layout class="test" v-if="layout=='dashboard'">
    <router-view class="dashboard-router-view" />
  </dashboard-layout>
  <login-layout v-else-if="layout=='login'">
    <router-view />
  </login-layout>
  <vuetify-layout v-else-if="layout ==='vuetify'">
    <router-view />
  </vuetify-layout>
  <ao-layout v-else-if="layout=='ao'">
    <router-view />
  </ao-layout>
</template>
<script>
import DashboardLayout from '@/layouts/Dashboard.vue';
import LoginLayout from '@/layouts/Login.vue';
import AoLayout from '@/layouts/AO.vue';
import VuetifyLayout from '@/layouts/Vuetify.vue';

import { isUserLoggedIn } from '@/utils/general';

export default {
  components: { DashboardLayout, LoginLayout, AoLayout, VuetifyLayout },
  name: 'Home',
  computed: {
    layout:function() {
      return this.$route.meta && this.$route.meta.layout || 'dashboard'
    }
  },
  created() {
    // user login check logic here
    if(this.$route.path !== '/welcome' && this.$route.path !== '/kyc/idv-callback' && this.$route.path != '/legal' && !isUserLoggedIn())
      this.$router.push('/welcome');
  }
};
</script>

<style lang="scss" scoped>
  .dashboard-router-view {
    width: 100%;
  }
</style>